import React from 'react';

import { useFormContext } from 'react-hook-form';

import { StoreBodyBlock } from 'constants/enums';
import { useTemplateStudioState } from 'state/hooks/template-studio.hook';
import {
  ETemplateStudioSidebarBlock,
  TemplateStudioBlock
} from 'state/template-studio.state.service';
import { z } from 'zod';

import { FormField } from 'components/ui';
import { Tabs, TabsList, TabsTrigger } from 'components/ui/tabs';

import { templateStudioSchema } from '../../../validation-schema';
import { ThemesFormItem } from '../Components/ThemesFormItem';

export const TemplateStudioRewardCalendarForm: React.FC = () => {
  const { control } = useFormContext<z.infer<typeof templateStudioSchema>>();
  const {
    setOpenSecondarySidebarBlock,
    openSecondarySidebarBlock,
    supportedThemesForRewardCalendar
  } = useTemplateStudioState();

  const toggleSecondarySidebar = (block: TemplateStudioBlock): void => {
    setOpenSecondarySidebarBlock(undefined);
    if (openSecondarySidebarBlock !== block) {
      setTimeout(() => {
        setOpenSecondarySidebarBlock(block);
      }, 100);
    }
  };

  const handleWidgetClick = (): void => {
    toggleSecondarySidebar(StoreBodyBlock.rewardCalendar);
  };

  const handlePopupClick = (): void => {
    toggleSecondarySidebar(ETemplateStudioSidebarBlock.REWARD_CALENDAR_POPUP);
  };

  if (!supportedThemesForRewardCalendar) return null;

  return (
    <>
      <FormField
        control={control}
        name="rewardCalendar.themes"
        render={({ field }) => (
          <ThemesFormItem
            onChange={field.onChange}
            value={field.value || []}
            supportedThemes={supportedThemesForRewardCalendar}
            themesSelectDataTestId="TemplatesStudio-RewardCalendar-themes"
          />
        )}
      />
      <div className="flex gap-2 mt-2 justify-between">
        <div className="text-sm">Element Type</div>
        <Tabs defaultValue="badge" orientation="vertical">
          <TabsList className="flex-col bg-base-muted h-[76px]">
            <TabsTrigger
              value="badge"
              onClick={handleWidgetClick}
              className="h-[34px] w-[120px] data-[state=active]:bg-base-background data-[state=active]:text-indigo-500 text-base-mutedForeground"
            >
              Badge
            </TabsTrigger>
            <TabsTrigger
              value="popup"
              onClick={handlePopupClick}
              className="h-[34px] w-[120px] data-[state=active]:bg-base-background data-[state=active]:text-indigo-500 text-base-mutedForeground"
            >
              Popup
            </TabsTrigger>
          </TabsList>
        </Tabs>
      </div>
    </>
  );
};
